import React, { useEffect } from 'react';
import styles from './travel-alert.module.scss';
import DashboardNavbar from '../../../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../../../../examples/LayoutContainers/DashboardLayout';
import { Card, CardContent, Grid } from '@mui/material';
import useFetchTravelAlertsData from '../useFetchTravelAlertsData';
import { useTranslation } from 'react-i18next';
import typography from '../../../../assets/theme/base/typography';
import { format } from 'date-fns';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import SoftButton from 'components/SoftButton';
import BlockRenderer from 'components/StrapiBlockRenderer';
import SoftTypography from '../../../../components/SoftTypography';
import colors from '../../../../assets/theme/base/colors';

const TravelAlert = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data, fetchData } = useFetchTravelAlertsData();
  const { body2 } = typography;
  const { id } = useParams();

  useEffect(() => {
    fetchData(id);
  }, []);

  const handleBackButton = () => {
    navigate('/travel-alerts');
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div className={styles.MyProfile} data-testid="TravelAlerts">
        <Grid container spacing={2} ml={0} pr={15} mt={5}>
          <Grid item xs={12}>
            {data ? (
              <Card>
                <CardContent sx={{ margin: 5 }}>
                  <SoftTypography variant="caption" fontSize={body2.fontSize}>
                    {format(
                      new Date(data.attributes.date),
                      data.attributes.dateFormat,
                    )}
                  </SoftTypography>
                  <SoftTypography
                    variant="h2"
                    mb={2}
                    sx={{ color: colors.black.main }}
                  >
                    {data.attributes.title}
                  </SoftTypography>
                  <BlockRenderer content={data.attributes.fullDescription} />
                </CardContent>
              </Card>
            ) : (
              <SoftTypography>
                {t('TRAVEL_ALERTS.noneAvailable')}
              </SoftTypography>
            )}
          </Grid>
          <Grid item>
            <SoftButton
              variant="outlined"
              color="secondary"
              mt={10}
              onClick={handleBackButton}
              sx={{ '&:hover': { borderColor: '#0a76ec' } }}
            >
              {t('TRAVEL_ALERTS.backButton')}
            </SoftButton>
          </Grid>
        </Grid>
      </div>
    </DashboardLayout>
  );
};

TravelAlert.propTypes = {};

TravelAlert.defaultProps = {};

export default TravelAlert;
